// @flow
import styled from "styled-components"

export const LoggedOutNavWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedOutNav/styled.js